module.exports = __webpack_public_path__ + "media/images/emoticons/ski-d26bff7d8449fe7c28921fb9a11473c1.gif";